"use strict";

var _classCallCheck = require("C:\\Users\\andrew.charlebois\\Documents\\personal-projects\\react-chat-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\andrew.charlebois\\Documents\\personal-projects\\react-chat-app\\node_modules\\@babel\\runtime/helpers/createClass");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var platform_node_1 = require("@pusher/platform-node");

var utils_1 = require("./utils");

var package_json_1 = __importDefault(require("../package.json"));

;
;
var TOKEN_EXPIRY_LEEWAY = 30;

var Chatkit =
/*#__PURE__*/
function () {
  function Chatkit(options) {
    _classCallCheck(this, Chatkit);

    var instanceLocator = options.instanceLocator,
        key = options.key,
        port = options.port,
        host = options.host,
        client = options.client;
    var sdkInfo = new platform_node_1.SDKInfo({
      productName: 'chatkit',
      version: package_json_1.default.version
    });
    var instanceOptions = {
      locator: instanceLocator,
      key: key,
      port: port,
      host: host,
      client: client,
      sdkInfo: sdkInfo
    };
    var apiInstanceOptions = Object.assign({}, instanceOptions, {
      serviceName: 'chatkit',
      serviceVersion: 'v2'
    });
    var authorizerInstanceOptions = Object.assign({}, instanceOptions, {
      serviceName: 'chatkit_authorizer',
      serviceVersion: 'v2'
    });
    var cursorsInstanceOptions = Object.assign({}, instanceOptions, {
      serviceName: 'chatkit_cursors',
      serviceVersion: 'v2'
    });
    this.instanceLocator = instanceLocator;
    this.apiInstance = new platform_node_1.Instance(apiInstanceOptions);
    this.authorizerInstance = new platform_node_1.Instance(authorizerInstanceOptions);
    this.cursorsInstance = new platform_node_1.Instance(cursorsInstanceOptions);
  } // Token generation


  _createClass(Chatkit, [{
    key: "authenticate",
    value: function authenticate(options) {
      var userId = options.userId,
          authPayload = options.authPayload;
      return this.apiInstance.authenticate(authPayload || {
        grant_type: 'client_credentials'
      }, {
        userId: userId
      });
    } // Used internally - not designed to be used externally

  }, {
    key: "generateAccessToken",
    value: function generateAccessToken(options) {
      return this.apiInstance.generateAccessToken(options);
    } // User interactions

  }, {
    key: "createUser",
    value: function createUser(options) {
      var id = options.id,
          name = options.name;
      return this.apiInstance.request({
        method: 'POST',
        path: "/users",
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          id: id,
          name: name,
          avatar_url: options.avatarURL,
          custom_data: options.customData
        },
        jwt: this.getServerToken()
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "createUsers",
    value: function createUsers(options) {
      var users = options.users.map(function (user) {
        var id = user.id,
            name = user.name;
        return {
          id: id,
          name: name,
          avatar_url: user.avatarURL,
          custom_data: user.customData
        };
      });
      return this.apiInstance.request({
        method: 'POST',
        path: "/batch_users",
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          users: users
        },
        jwt: this.getServerToken()
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "updateUser",
    value: function updateUser(options) {
      var jwt = this.generateAccessToken({
        su: true,
        userId: options.id
      });
      var updatePayload = {};

      if (options.name) {
        updatePayload.name = options.name;
      }

      ;

      if (options.avatarURL) {
        updatePayload.avatar_url = options.avatarURL;
      }

      ;

      if (options.customData) {
        updatePayload.custom_data = options.customData;
      }

      ;
      return this.apiInstance.request({
        method: 'PUT',
        path: "/users/".concat(options.id),
        headers: {
          'Content-Type': 'application/json'
        },
        body: updatePayload,
        jwt: jwt.token
      }).then(function () {});
    }
  }, {
    key: "deleteUser",
    value: function deleteUser(options) {
      return this.apiInstance.request({
        method: 'DELETE',
        path: "/users/".concat(options.userId),
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "getUser",
    value: function getUser(options) {
      return this.apiInstance.request({
        method: 'GET',
        path: "/users/".concat(encodeURIComponent(options.id)),
        jwt: this.getServerToken()
      }).then(function (_ref) {
        var body = _ref.body;
        return JSON.parse(body);
      });
    }
  }, {
    key: "getUsers",
    value: function getUsers() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.apiInstance.request({
        method: 'GET',
        path: "/users",
        qs: {
          from_ts: options.fromTimestamp,
          limit: options.limit
        },
        jwt: this.getServerToken()
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "getUsersById",
    value: function getUsersById(options) {
      return this.apiInstance.request({
        method: 'GET',
        path: "/users_by_ids",
        qs: {
          id: options.userIds
        },
        useQuerystring: true,
        jwt: this.getServerToken()
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    } // Room interactions

  }, {
    key: "getRoom",
    value: function getRoom(options) {
      var jwt = this.generateAccessToken({
        su: true
      });
      return this.apiInstance.request({
        method: 'GET',
        path: "/rooms/".concat(encodeURIComponent(options.roomId)),
        jwt: jwt.token
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(options) {
      var messagePayload = {
        text: options.text
      };

      if (options.attachment) {
        messagePayload.attachment = {
          resource_link: options.attachment.resourceLink,
          type: options.attachment.type
        };
      }

      return this.apiInstance.request({
        method: 'POST',
        path: "/rooms/".concat(encodeURIComponent(options.roomId), "/messages"),
        jwt: this.generateAccessToken({
          su: true,
          userId: options.userId
        }).token,
        body: messagePayload
      }).then(function (_ref2) {
        var body = _ref2.body;
        return JSON.parse(body);
      });
    }
  }, {
    key: "deleteMessage",
    value: function deleteMessage(options) {
      return this.apiInstance.request({
        method: 'DELETE',
        path: "/messages/".concat(options.id),
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "getRoomMessages",
    value: function getRoomMessages(options) {
      var jwt = this.generateAccessToken({
        su: true
      });

      var initialId = options.initialId,
          optionsMinusInitialId = __rest(options, ["initialId"]);

      var qs = optionsMinusInitialId;

      if (initialId) {
        qs['initial_id'] = initialId;
      }

      return this.apiInstance.request({
        method: 'GET',
        path: "/rooms/".concat(encodeURIComponent(options.roomId), "/messages"),
        jwt: jwt.token,
        qs: qs
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "getRooms",
    value: function getRooms() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.apiInstance.request({
        method: 'GET',
        path: "/rooms",
        jwt: this.getServerToken(),
        qs: {
          from_id: options.fromId,
          include_private: options.includePrivate
        }
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "getUserRooms",
    value: function getUserRooms(options) {
      var jwt = this.generateAccessToken({
        su: true,
        userId: options.userId
      });
      return this.apiInstance.request({
        method: 'GET',
        path: "/users/".concat(options.userId, "/rooms"),
        jwt: jwt.token
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "getUserJoinableRooms",
    value: function getUserJoinableRooms(options) {
      var jwt = this.generateAccessToken({
        su: true,
        userId: options.userId
      });
      return this.apiInstance.request({
        method: 'GET',
        path: "/users/".concat(options.userId, "/rooms"),
        qs: {
          joinable: true
        },
        jwt: jwt.token
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "createRoom",
    value: function createRoom(options) {
      var jwt = this.generateAccessToken({
        su: true,
        userId: options.creatorId
      });
      var name = options.name,
          isPrivate = options.isPrivate,
          userIds = options.userIds,
          customData = options.customData;
      var roomPayload = {
        name: name,
        private: isPrivate || false
      };

      if (userIds && userIds.length !== 0) {
        roomPayload['user_ids'] = userIds;
      }

      if (customData) {
        roomPayload.custom_data = customData;
      }

      return this.apiInstance.request({
        method: 'POST',
        path: '/rooms',
        jwt: jwt.token,
        body: roomPayload
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "updateRoom",
    value: function updateRoom(options) {
      var body = {};

      if (options.name) {
        body.name = options.name;
      }

      if (options.isPrivate) {
        body.private = options.isPrivate;
      }

      if (options.customData) {
        body.custom_data = options.customData;
      }

      return this.apiInstance.request({
        method: 'PUT',
        path: "/rooms/".concat(options.id),
        jwt: this.getServerToken(),
        body: body
      }).then(function () {});
    }
  }, {
    key: "deleteRoom",
    value: function deleteRoom(options) {
      return this.apiInstance.request({
        method: 'DELETE',
        path: "/rooms/".concat(options.id),
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "addUsersToRoom",
    value: function addUsersToRoom(options) {
      return this.apiInstance.request({
        method: 'PUT',
        path: "/rooms/".concat(encodeURIComponent(options.roomId), "/users/add"),
        jwt: this.getServerToken(),
        body: {
          user_ids: options.userIds
        }
      }).then(function () {});
    }
  }, {
    key: "removeUsersFromRoom",
    value: function removeUsersFromRoom(options) {
      return this.apiInstance.request({
        method: 'PUT',
        path: "/rooms/".concat(encodeURIComponent(options.roomId), "/users/remove"),
        jwt: this.getServerToken(),
        body: {
          user_ids: options.userIds
        }
      }).then(function () {});
    } // Authorizer interactions

  }, {
    key: "createRoomRole",
    value: function createRoomRole(options) {
      return this.createRole(Object.assign({}, options, {
        scope: 'room'
      }));
    }
  }, {
    key: "createGlobalRole",
    value: function createGlobalRole(options) {
      return this.createRole(Object.assign({}, options, {
        scope: 'global'
      }));
    }
  }, {
    key: "createRole",
    value: function createRole(options) {
      return this.authorizerInstance.request({
        method: 'POST',
        path: "/roles",
        headers: {
          'Content-Type': 'application/json'
        },
        body: options,
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "deleteGlobalRole",
    value: function deleteGlobalRole(options) {
      return this.authorizerInstance.request({
        method: 'DELETE',
        path: "/roles/".concat(options.name, "/scope/global"),
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "deleteRoomRole",
    value: function deleteRoomRole(options) {
      return this.authorizerInstance.request({
        method: 'DELETE',
        path: "/roles/".concat(options.name, "/scope/room"),
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "assignGlobalRoleToUser",
    value: function assignGlobalRoleToUser(options) {
      return this.assignRoleToUser(options);
    }
  }, {
    key: "assignRoomRoleToUser",
    value: function assignRoomRoleToUser(options) {
      return this.assignRoleToUser(options);
    }
  }, {
    key: "assignRoleToUser",
    value: function assignRoleToUser(options) {
      return this.authorizerInstance.request({
        method: 'PUT',
        path: "/users/".concat(options.userId, "/roles"),
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          name: options.name,
          room_id: options.roomId
        },
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "getUserRoles",
    value: function getUserRoles(options) {
      return this.authorizerInstance.request({
        method: 'GET',
        path: "/users/".concat(options.userId, "/roles"),
        jwt: this.getServerToken()
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "removeGlobalRoleForUser",
    value: function removeGlobalRoleForUser(options) {
      return this.authorizerInstance.request({
        method: 'DELETE',
        path: "/users/".concat(options.userId, "/roles"),
        headers: {
          'Content-Type': 'application/json'
        },
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "removeRoomRoleForUser",
    value: function removeRoomRoleForUser(options) {
      return this.authorizerInstance.request({
        method: 'DELETE',
        path: "/users/".concat(options.userId, "/roles"),
        headers: {
          'Content-Type': 'application/json'
        },
        qs: {
          room_id: options.roomId
        },
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "getPermissionsForGlobalRole",
    value: function getPermissionsForGlobalRole(options) {
      return this.authorizerInstance.request({
        method: 'GET',
        path: "/roles/".concat(options.name, "/scope/global/permissions"),
        jwt: this.getServerToken()
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "getPermissionsForRoomRole",
    value: function getPermissionsForRoomRole(options) {
      return this.authorizerInstance.request({
        method: 'GET',
        path: "/roles/".concat(options.name, "/scope/room/permissions"),
        jwt: this.getServerToken()
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    }
  }, {
    key: "updatePermissionsForGlobalRole",
    value: function updatePermissionsForGlobalRole(options) {
      return this.updatePermissionsForRole(options.name, 'global', options.permissionsToAdd || [], options.permissionsToRemove || []);
    }
  }, {
    key: "updatePermissionsForRoomRole",
    value: function updatePermissionsForRoomRole(options) {
      return this.updatePermissionsForRole(options.name, 'room', options.permissionsToAdd || [], options.permissionsToRemove || []);
    }
  }, {
    key: "getRoles",
    value: function getRoles() {
      return this.authorizerInstance.request({
        method: 'GET',
        path: "/roles",
        jwt: this.getServerToken()
      }).then(function (res) {
        return JSON.parse(res.body);
      });
    } // Cursors

  }, {
    key: "setReadCursor",
    value: function setReadCursor(options) {
      return this.cursorsInstance.request({
        method: 'PUT',
        path: "/cursors/0/rooms/".concat(encodeURIComponent(options.roomId), "/users/").concat(encodeURIComponent(options.userId)),
        body: {
          position: options.position
        },
        jwt: this.getServerToken()
      }).then(function () {});
    }
  }, {
    key: "getReadCursor",
    value: function getReadCursor(options) {
      return this.cursorsInstance.request({
        method: 'GET',
        path: "/cursors/0/rooms/".concat(encodeURIComponent(options.roomId), "/users/").concat(encodeURIComponent(options.userId)),
        jwt: this.getServerToken()
      }).then(function (_ref3) {
        var body = _ref3.body;
        return JSON.parse(body);
      });
    }
  }, {
    key: "getReadCursorsForUser",
    value: function getReadCursorsForUser(options) {
      return this.cursorsInstance.request({
        method: 'GET',
        path: "/cursors/0/users/".concat(encodeURIComponent(options.userId)),
        jwt: this.getServerToken()
      }).then(function (_ref4) {
        var body = _ref4.body;
        return JSON.parse(body);
      });
    }
  }, {
    key: "getReadCursorsForRoom",
    value: function getReadCursorsForRoom(options) {
      return this.cursorsInstance.request({
        method: 'GET',
        path: "/cursors/0/rooms/".concat(encodeURIComponent(options.roomId)),
        jwt: this.getServerToken()
      }).then(function (_ref5) {
        var body = _ref5.body;
        return JSON.parse(body);
      });
    } // General requests

  }, {
    key: "apiRequest",
    value: function apiRequest(options) {
      options.jwt = options.jwt || this.getServerToken();
      return this.apiInstance.request(options);
    }
  }, {
    key: "authorizerRequest",
    value: function authorizerRequest(options) {
      options.jwt = options.jwt || this.getServerToken();
      return this.authorizerInstance.request(options);
    }
  }, {
    key: "cursorsRequest",
    value: function cursorsRequest(options) {
      options.jwt = options.jwt || this.getServerToken();
      return this.cursorsInstance.request(options);
    }
  }, {
    key: "updatePermissionsForRole",
    value: function updatePermissionsForRole(name, scope) {
      var permissionsToadd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var permissionsToRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      if (permissionsToadd.length === 0 && permissionsToRemove.length === 0) {
        throw new Error("Either permissionsToAdd or permissionsToRemove is required");
      }

      var body = {};

      if (permissionsToadd.length > 0) {
        body['add_permissions'] = permissionsToadd;
      }

      if (permissionsToRemove.length > 0) {
        body['remove_permissions'] = permissionsToRemove;
      }

      return this.authorizerInstance.request({
        method: 'PUT',
        path: "/roles/".concat(name, "/scope/").concat(scope, "/permissions"),
        headers: {
          'Content-Type': 'application/json'
        },
        body: body,
        jwt: this.getServerToken()
      }).then(function () {});
    }
    /**
     * This method manages the token for http library and pusher platform
     * communication
     */

  }, {
    key: "getServerToken",
    value: function getServerToken() {
      if (this.tokenWithExpiry && this.tokenWithExpiry.expiresAt > utils_1.getCurrentTimeInSeconds()) {
        return this.tokenWithExpiry.token;
      } // Otherwise generate new token and its expiration time


      var tokenWithExpiresIn = this.apiInstance.generateAccessToken({
        su: true
      });
      this.tokenWithExpiry = {
        token: tokenWithExpiresIn.token,
        expiresAt: utils_1.getCurrentTimeInSeconds() + tokenWithExpiresIn.expires_in - TOKEN_EXPIRY_LEEWAY
      };
      return this.tokenWithExpiry.token;
    }
  }]);

  return Chatkit;
}();

exports.default = Chatkit;
;